import React from 'react';

// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as Fields from './Fields';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as m from '../../messages';
import { TranslatedMessage } from 'common/components/Intl';

const GenderFieldGroup = ({ options }) => {
  return (
    <div className="AddressForm__group">
      <div className="AddressForm__group-title natural-heading--small">
        <TranslatedMessage id={m.GENDER_TITLE} />
      </div>

      <p className="text flat-blue" />

      <div className="row">
        <div className="col-xs-12">
          <Fields.Gender placeholder={m.GENDER_PLACEHOLDER} options={options} />
        </div>
      </div>
    </div>
  );
};

export default GenderFieldGroup;
